import { LaborCategoryCatalog } from "@/components/admin/LaborCategoryCatalog";

export function SettingsLaborCategoriesPage() {
  return <LaborCategoryCatalog />;
}
